import * as THREE from "three";

export const creatorItems = [
  {
    modelPath: "/letters_3D/P.glb",
    position: new THREE.Vector3(-22, 0, -7),
    rotation: new THREE.Euler(0, (24.3 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "statue",
    enableCollision: true,
    enablePhysics: true,
    mass: 20,
    friction: 0.8,
    physicsShape: "box",
    // Statue-specific zone properties (same as signpost)
    // zoneWidth: 4,
    // zoneDepth: 4,
    url: "https://www.patreon.com/c/Kyoronginus",
    name: "Patreon",
  },
  {
    modelPath: "/social_media_x.glb",
    position: new THREE.Vector3(-18, 0, -7),
    rotation: new THREE.Euler(0, (1.7 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "statue",
    enableCollision: true,
    enablePhysics: true,
    mass: 20,
    friction: 0.8,
    physicsShape: "box",
    // Statue-specific zone properties (same as signpost)
    // zoneWidth: 1,
    // zoneDepth: 1,
    url: "https://x.com/ ",
    name: "X",
  },
  {
    modelPath: "/letters_3D/P_bold.glb",
    position: new THREE.Vector3(-26, 0, -7),
    rotation: new THREE.Euler(0, (3.9 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "statue",
    enableCollision: true,
    enablePhysics: true,
    mass: 20,
    friction: 0.8,
    physicsShape: "box",
    // Statue-specific zone properties (same as signpost)
    // zoneWidth: 4,
    // zoneDepth: 2,
    url: "https://www.pixiv.net/users/34124210",
    name: "pixiv",
  },
  {
    modelPath: "/social_media_github.glb",
    position: new THREE.Vector3(-14, 0, -7),
    rotation: new THREE.Euler(0, (-0.3 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "statue",
    enableCollision: true,
    enablePhysics: true,
    mass: 20,
    friction: 0.8,
    physicsShape: "box",
    // Statue-specific zone properties (same as signpost)
    zoneWidth: 20,
    zoneDepth: 1,
    url: "https://github.com/Kyoronginus",
    name: "Github",
  },
  {
    modelPath: "/fibonacci_logo.glb",
    position: new THREE.Vector3(-22, 0, 1),
    rotation: new THREE.Euler(0, (3.1 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "statue",
    enableCollision: true,
    enablePhysics: true,
    mass: 20,
    friction: 0.8,
    physicsShape: "box",
    // Statue-specific zone properties (same as signpost)
    // zoneWidth: 4,
    // zoneDepth: 2,
    url: "https://fibonacci-spiral-detecti-bf743.web.app/",
    name: "Fibonacci Spiral Detection",
  },
  {
    modelPath: "/social_media_placeholder.glb",
    position: new THREE.Vector3(-18, 0, 1),
    rotation: new THREE.Euler(0, (3.1 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(1.5, 1.5, 1.5),
    type: "statue",
    enableCollision: true,
    enablePhysics: true,
    mass: 10,
    friction: 0.8,
    physicsShape: "box",
    // Statue-specific zone properties (same as signpost)
    // zoneWidth: 4,
    // zoneDepth: 2,
    url: "https://coloranalyzer-648561351861.us-central1.run.app/",
    name: "Color Analyzer",
  },
];
